import axios from 'axios'

// const APIKEY = 'AIzaSyCBE8n8ob-amB9zM_Uo1uZ13TxclYFBCVs'
const MAPSURL = (address) => encodeURI(`https://maps.google.com/maps/api/geocode/json?address=${address}`)

const GetAddressData = (address) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: MAPSURL(address)
    })
      .then(success => {
        resolve(success)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export {
  GetAddressData
}



// WEBPACK FOOTER //
// ./src/api/gmaps.js